exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ChannelCard {\n  /*.ChannelCard__status-alert-list {*/\n  /*    margin-top: 5px;*/\n  /*    margin-bottom: 2px;*/\n  /*}*/\n}\n.ChannelCard .PlatformIcon {\n  font-size: 50px;\n}\n.ChannelCard .ChannelCard__status .label {\n  padding: 6px 12px;\n}\n@media (max-width: 767px) {\n.ChannelCard .ChannelCard__button-bar .btn {\n    width: 100%;\n    margin-bottom: 10px;\n}\n}\n.ChannelCard .fa-bolt {\n  color: yellow;\n  font-size: 150%;\n  position: relative;\n  top: 2px;\n  left: -5px;\n}\n", ""]);

// exports
